import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#7540ee",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.8",
      d: "M8.7 15.6a1.2 1.2 0 0 1-1.74 1.069l-4.8-2.4A1.2 1.2 0 0 1 1.5 13.2v-12l6.54 3.264a1.2 1.2 0 0 1 .66 1.08z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#7540ee",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.8",
      d: "M1.5 1.2h10.8a1.2 1.2 0 0 1 1.2 1.2v10.8a1.2 1.2 0 0 1-1.2 1.2H8.7"
    }, null, -1)
  ]))]))
}
export default { render: render }